module.exports = __webpack_public_path__ + "static/media/risk-profile-bg.6f51ce59.png";